export class AlertService {
    static $inject: string[] = [
        '$rootScope',
        '$uibModal'
    ];

    constructor(
        private $rootScope: any,
        private $uibModal: ng.ui.bootstrap.IModalService
    ) {
    }

    alert(type: string, message: any) {
        if (message !== null && typeof message === 'object') {
            message = JSON.stringify(message);
        }
        let headerIcon = 'fa fa-info';
        let headerText = 'Informazione';
        switch (type) {
            case 'info':
                headerIcon = 'fa fa-info-circle';
                headerText = 'Informazione';
                break;
            case 'error':
                if (message === 'Credentials are required to access this resource.') {
                    window.localStorage.clear();
                    location.reload(true);

                    this.$rootScope.subscriptionCancelled = false;
                    this.$rootScope.subscriptionExpired = false;
                    return;
                }

                headerIcon = 'fa fa-exclamation-circle';
                headerText = 'Errore';
                break;
            case 'warning':
                headerIcon = 'fa fa-exclamation-circle';
                headerText = 'Attenzione';
                break;
        }

        this.$uibModal.open({
            component: 'defaultModalComponent',
            windowClass: 'center-modal',
            controllerAs: '$ctrl',
            resolve: {
                config: () => {
                    return {
                        headerIcon: headerIcon,
                        headerText: headerText,
                        bodyHtml: message,
                        buttons: [
                            {
                                'id': 1,
                                'icon': 'fa fa-check',
                                'label': 'OK'
                            }
                        ]
                    };
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/ui/alert.service.ts